import './Container.css';
import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';

interface Props extends GlobalProps {
  isMobile?: boolean;
  isLeftAligned?: boolean;
}

export function Container({ className, style, children, isMobile = false, isLeftAligned = false }: Props): JSX.Element {
  return (
    <div
      className={classnames('container', className, {
        'container--mobile': isMobile,
        'container--align-left': isLeftAligned,
      })}
      style={style}
    >
      <div className="container__content">{children}</div>
    </div>
  );
}
